// Browser helpers for the Opinly pixel on app.funnelkeeper.com.
// The pixel is a raw script tag in index.html (no framework queue), so
// calls wait for `opinly:ready` and no-op if the script never lands.

type OpinlyPixel = {
  anonId: string;
  track: (
    event: string,
    properties?: Record<string, unknown>,
    opts?: { externalEventId?: string },
  ) => void;
  identify: (who: { email: string; userId?: string }) => void;
};

declare global {
  interface Window {
    opinly?: OpinlyPixel;
  }
}

function whenReady(fn: (pixel: OpinlyPixel) => void): void {
  if (typeof window === "undefined") return;
  const run = () => {
    if (window.opinly) fn(window.opinly);
  };
  if (window.opinly) run();
  else window.addEventListener("opinly:ready", run, { once: true });
}

export function opinlyIdentify(who: { email: string; userId?: string }): void {
  if (!who.email) return;
  whenReady((pixel) => pixel.identify({ email: who.email, userId: who.userId }));
}

export function opinlyTrack(
  event: string,
  properties?: Record<string, unknown>,
  opts?: { externalEventId?: string },
): void {
  whenReady((pixel) => pixel.track(event, properties, opts));
}

export function opinlyAnonId(): string | undefined {
  if (typeof window === "undefined") return undefined;
  const id = window.opinly?.anonId?.trim();
  return id || undefined;
}

/** Same string the API uses so the browser + server sign_up dedupe. */
export function signupEventId(email: string): string {
  return `signup:${email.trim().toLowerCase()}`;
}
